import React from "react"
import ReactDOM from "react-dom/client"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import store from "./store"
import { RouteHistoryProvider } from "context/RouteHistoryContext"

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60, // 60 minutes
      cacheTime: 1000 * 60 * 60, // 60 minutes
      retry: 2, // Retry failed requests 2 times
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <RouteHistoryProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          <ToastContainer theme="light" position="top-right" />

            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </RouteHistoryProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
)

serviceWorker.unregister()
